"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffInTime = void 0;
const date_fns_1 = require("date-fns");
function plural(amt, word) {
    return amt > 1 ? `${word}s` : word;
}
function diffInTime(date1, date2) {
    const months = date_fns_1.differenceInMonths(date1, date2);
    if (months > 0) {
        return `${months} ${plural(months, 'month')} ago`;
    }
    const days = date_fns_1.differenceInDays(date1, date2);
    if (days > 0) {
        return `${days} ${plural(days, 'day')} ago`;
    }
    const hours = date_fns_1.differenceInHours(date1, date2);
    if (hours > 0) {
        return `${hours} ${plural(hours, 'hour')} ago`;
    }
    const minutes = date_fns_1.differenceInMinutes(date1, date2);
    if (minutes > 0) {
        return `${minutes} ${plural(minutes, 'minute')} ago`;
    }
    return 'Few seconds ago';
}
exports.diffInTime = diffInTime;
